var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.modalFlag)?_c('div',{staticClass:"modal"},[_c('i',{class:['iconfont', _vm.flag === false ? 'icon-a-cuowu2x1' : 'icon-a-chenggong2x']}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }